import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { ChatComponent } from "Components/shared";
import {
    fetchChatToken,
    fetchUserListInfo,
    fetchConvesationList,
    createConversationByUser,
    fetchConvesationUsersList,
    createMessage,
    fetchMessages,
    updateMessageList,
    checkUserOnline
} from 'Services/chat.service';
import { getProfileID } from 'Helpers/session';
import { isEmpty, last, map, some, isUndefined, cloneDeep, uniqBy, filter, find, isNil } from 'lodash';
import { statusChatAtom } from 'Recoil/chat.atom';
import { useRecoilState } from 'recoil';
import { io } from "socket.io-client";
import useSession from 'Hooks/session.hook';
import moment from 'moment';
import { encode } from 'Helpers/index';
import { messageStatusAtom } from 'Recoil/message.atom';
import { BasicModal } from "@life-line-lab/components-react";
import ChooseProducts from './modals/products/products';
import ChooseOrders from './modals/orders/orders';
import { fetchProductList } from 'Services/inventory.services';
import { fetchOrderList } from "Services/order.services";


const ChatConversation: React.FC<any> = () => {


    const history = useHistory();
    const [conversation, setConversation] = useState<any>();
    const { t } = useTranslation();
    let socket;
    const [conversationList, setConversationList] = useState<any>()
    const [selectedConversation, setSelectedConversation] = useState<any>()
    const [chatBoxStatus, setChatBoxStatus] = useState<any>(false)
    const [chatStatusState, setChatStatusState] = useRecoilState<any>(statusChatAtom);
    const [sendMsgState, setSendMsgState] = useRecoilState<any>(messageStatusAtom)
    const [userChatInfo, setUserChatInfo] = useState<any>({});
    const profileID = getProfileID();
    const [onlineUserlist, setOnlineUserlist] = useState<any>()
    const { profile } = useSession();
    const [socketConversation, setSocketConversation] = useState<any>()
    const [defaultMsg, setDefaultMsg] = useState<any>()
    const [showConversationContainer, setShowConversationContainer] = useState(false);
    const [defaultSupplier, setDefaultSupplier] = useState<any>()
    const [image, setImage] = useState("");
    const inputFile = useRef(null);
    const [offlineUser, setOfflineUser] = useState<any>()
    const [isProducts, setIsProducts] = useState<any>(false)
    const [isOrders, setIsOrders] = useState<any>(false);
    const [productList, setProductList] = useState<any>([]);
    const [orderList, setOrderList] = useState<any>([]);

    useEffect(() => {
        if (socketConversation) {
            handleSocketConversation(socketConversation)
        }
    }, [socketConversation])

    useEffect(() => {
        if (offlineUser) {
            updateOnlineUsers(offlineUser)
        }
    }, [offlineUser])

    useEffect(() => {
        handleToken();
        return () => {
            socket.disconnect();
        }
    }, [profileID])


    useEffect(() => {
        setConversation(selectedConversation)
    }, [selectedConversation])


    useEffect(() => {
        if (chatStatusState.status.supplier) {
            setChatBoxStatus(true)
            getConversationList()
            let message = `Hi, I would like to enquire about ${chatStatusState.info.product.productName}`
            setDefaultMsg(message);
            setDefaultSupplier(chatStatusState.info.orgData.name.toLowerCase())

        } else {
            setDefaultMsg(null);
            setDefaultSupplier(null);
        }
    }, [chatStatusState.status.supplier])

    useEffect(() => {
        if (!chatStatusState.status.supplier && userChatInfo && chatBoxStatus) {
            handleFetchConversation()
        }
    }, [userChatInfo, chatStatusState.status.supplier, chatBoxStatus])

    const [socketObj, setSocketObj] = useState<any>('')
    const startSocket = (obj) => {
        setSocketObj(obj)
        socket = io(`${process.env.SOCKET_CONNECTION}`, {
            auth: obj,
            transports: ["websocket", "polling"],
            autoConnect: false,
            path: '/bot/socketIO/',
            secure: true
        });

        console.log("sockettt::", socket)

        if (socket.disconnected) {
            socket.connect();
        }

        socket.on("disconnect", () => {
            socket.off();
            socket.disconnect();
            //console.log("socket Disconnected", socket.disconnected);
        });

        socket.on("private_message", data => {
            if (data.recieverID) {
                console.log("private_message", data)
                setSocketConversation(data);
            }

        })
        socket.on("user_online", list => {
            list = uniqBy(list, 'refID')
            let onlineUsers = list.filter(user => user.refID !== profileID);
            setOnlineUserlist(onlineUsers);
            console.log("user_online", onlineUsers)
        });


        socket.on("user_offline", offlineUser => {
            if (offlineUser) {
                setOfflineUser(offlineUser)
            }
        })

        socket.on("connect_error", (err) => { console.log(`socket_connect_error due to ${err.message}`); });


    }

    const updateOnlineUsers = (offlineUser) => {
        let usersList = cloneDeep(onlineUserlist)
        let latestUsers = usersList.filter(user => user.refID !== offlineUser.refID);
        setOnlineUserlist(latestUsers);
    }
    // console.log("onlineUserlist", onlineUserlist)

    const handleSocketConversation = async (data) => {

        if (selectedConversation !== undefined) {
            if (selectedConversation.conversationID == data.message.conversationID) {
                // console.log('chat box opened.........')
                let selConversationObj = cloneDeep(selectedConversation);
                let msgObj = getMsgFormatData(data.message, 'incoming')
                // console.log(msgObj)
                selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
                setSelectedConversation(selConversationObj);

                let updateMessagesList = {
                    messageIDs: [data.message.messageID],
                    readBy: {
                        user: userChatInfo._id,
                        readAt: new Date()
                    }
                }
                updateMessageList(updateMessagesList)
            }
            else {
                updateConversationList();
            }
        } else {
            updateConversationList();
        }

    }

    const updateConversationList = async () => {
        setConversationList({})
        // console.log('new message.......we push this message to contact list');
        const listOfUsers = await fetchConvesationUsersList({ conversationIDs: userChatInfo.conversationIDs })
        let obj = userChatInfo;
        obj.usersList = listOfUsers;
        //  console.log(JSON.stringify(obj))
        setConversationList(obj);
    }


    const handleToken = async () => {
        const profileID = getProfileID();
        const responseData: any = await fetchChatToken(profileID);
        if (!isNil(responseData) && responseData.token) {
            localStorage.setItem('CHAT_TOKEN', responseData.token.accessToken);
            let filters = {
                platform: process.env.ACCOUNT_TYPE,
                refID: profileID,
                totalCount: true
            }
            const userListInfo = await fetchUserListInfo(filters);
            if (!isNil(userListInfo) && userListInfo.count) {
                setUserChatInfo(userListInfo.fetchedUsers[0])

                let socketObj = {
                    username: userListInfo.fetchedUsers[0].nickName,
                    refID: userListInfo.fetchedUsers[0].refID,
                    userID: userListInfo.fetchedUsers[0]._id
                }

                let userObj = {
                    refID: userListInfo.fetchedUsers[0].refID,
                }
                // let status = await checkUserOnline(userObj);
                // //  console.log(status)

                // if (status.socketOccupied !== true) {
                //     startSocket(socketObj)
                // }

                startSocket(socketObj)
            }
        } else {
            let filters = {
                platform: process.env.ACCOUNT_TYPE,
                refID: profileID,
                totalCount: true
            }
            const userListInfo = await fetchUserListInfo(filters);
            if (!isNil(userListInfo) && userListInfo.count) {
                setUserChatInfo(userListInfo.fetchedUsers[0])

                let socketObj = {
                    username: userListInfo.fetchedUsers[0].nickName,
                    refID: userListInfo.fetchedUsers[0].refID,
                    userID: userListInfo.fetchedUsers[0]._id
                }
                let userObj = {
                    refID: userListInfo.fetchedUsers[0].refID,
                }
                // let status = await checkUserOnline(userObj);
                // // console.log(status)

                // if (status.socketOccupied !== true) {
                //     startSocket(socketObj)
                // }

                startSocket(socketObj)
            }

        }
    }

    const getConversationList = async () => {
        let obj = {
            platform: process.env.ACCOUNT_TYPE,
            userID: userChatInfo._id,
            totalCount: true
        }

        const conversationResponse = await fetchConvesationList(obj)

        var conversationID = '';
        if (conversationResponse.length) {
            for (var i = 0; i < conversationResponse.length; i++) {

                if (conversationResponse[i].user_to_data.refID == chatStatusState.info.orgID) {
                    conversationID = conversationResponse[i]._id;
                }
                if (conversationResponse[i].user_from_data.refID == chatStatusState.info.orgID) {
                    conversationID = conversationResponse[i]._id;
                }

            }

            if (conversationID) {

                const listOfUsers = await fetchConvesationUsersList({ conversationIDs: userChatInfo.conversationIDs })

                let obj = userChatInfo;
                obj.usersList = listOfUsers;
                setConversationList(obj);

                let msgRequest = {
                    "conversationID": conversationID,
                }
                const messagesList = await fetchMessages(msgRequest);


                let selObj: any = listOfUsers.find((obj) => { return obj.conversationID == conversationID });
                selObj.conversation = messagesList || [];
                setSelectedConversation(selObj)


            } else {
                createConversation()
            }
        } else {
            createConversation()
        }


    }

    const createConversation = async () => {
        let request = {
            profileID: profileID,
            username: profile.fullName,
            orgName: chatStatusState.info.orgData.name,
            orgID: chatStatusState.info.orgID,
            platform: process.env.ACCOUNT_TYPE
        }
        const createResponse = await createConversationByUser(request)
        let previousConversations: any = userChatInfo.conversationIDs ? userChatInfo.conversationIDs : [];
        previousConversations.push(createResponse.conversation._id)

        const listOfUsers = await fetchConvesationUsersList({ conversationIDs: previousConversations })

        let obj = userChatInfo;
        obj.usersList = listOfUsers;
        setConversationList(obj);

        let msgFetchRequest = {
            //"platform": process.env.ACCOUNT_TYPE,
            "conversationID": createResponse.conversation._id,
            //"totalCount": true
        }
        const messagesList = await fetchMessages(msgFetchRequest);


        let selObj: any = listOfUsers.find((obj) => { return obj.conversationID == createResponse.conversation._id });
        selObj.conversation = messagesList || [];
        setSelectedConversation(selObj)
    }


    const handleFetchConversation = async () => {

        if (userChatInfo.conversationIDs.length) {
            const listOfUsers = await fetchConvesationUsersList({ conversationIDs: userChatInfo.conversationIDs })
            let obj = userChatInfo;
            obj.usersList = listOfUsers;
            setConversationList(obj);
        }
    }

    const onSendMessage = async (input) => {
        setSendMsgState({ ...sendMsgState, create: 'loading' });

        let inputMsg = input.message.replace(/&nbsp;/gi, " ");
        inputMsg = inputMsg.replace(/\s+/g, ' ');

        const isOnlineUser = find(onlineUserlist, (o: any) => o.refID === selectedConversation.refID);

        //need to add isNill
        if (!isUndefined(isOnlineUser)) {
            // console.log("online message..")
            let msgCreateReq = {
                to: isOnlineUser.userID,
                platform: process.env.ACCOUNT_TYPE,
                message: {
                    sender: userChatInfo._id,
                    text: inputMsg.trim(),
                    employee: profile ? profile._id : '',
                    employeeName: profile ? profile.fullName : '',
                }
            }
            let msgCreate = await createMessage(msgCreateReq)
            // setSendMsgState({ ...sendMsgState, create: 'success' });
            setSendMsgState({ ...sendMsgState, create: 'idle' });

            let selConversationObj = cloneDeep(selectedConversation);
            let msgObj = getMsgFormatData(msgCreate.message, 'outgoing')
            // if (chatStatusState.status.supplier) {
            //     selConversationObj.conversation = [msgObj];
            //     setSelectedConversation(selConversationObj);
            //     setSendMsgState({ ...sendMsgState, create: 'idle' });
            // } else {
            //     selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
            //     setSelectedConversation(selConversationObj);
            //     setSendMsgState({ ...sendMsgState, create: 'idle' });
            // }

            if (chatStatusState.status.supplier) {
                if (selConversationObj.conversation.length) {
                    selConversationObj.conversation.push(msgObj)
                } else {
                    selConversationObj.conversation = [msgObj];
                }
                setSelectedConversation(selConversationObj);

            } else {
                selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
                setSelectedConversation(selConversationObj);
            }

        } else {
            let msgCreateReq = {
                message: {
                    conversationID: selectedConversation.conversationID,
                    sender: userChatInfo._id,
                    text: inputMsg.trim(),
                    employee: profile ? profile._id : '',
                    employeeName: profile ? profile.fullName : '',
                }
            }
            let msgCreate = await createMessage(msgCreateReq)
            // setSendMsgState({ ...sendMsgState, create: 'success' });
            setSendMsgState({ ...sendMsgState, create: 'idle' });
            //todo check response status
            let selConversationObj = cloneDeep(selectedConversation);

            let msgObj = getMsgFormatData(msgCreate.message, 'outgoing')
            if (chatStatusState.status.supplier) {
                if (selConversationObj.conversation.length) {
                    selConversationObj.conversation.push(msgObj)
                } else {
                    selConversationObj.conversation = [msgObj];
                }
                setSelectedConversation(selConversationObj);
            } else {
                selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
                setSelectedConversation(selConversationObj);

            }
            // selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
            // setSelectedConversation(selConversationObj);
            // setSendMsgState({ ...sendMsgState, create: 'idle' });

        }
    }

    const setChatWidgetStatus = (status) => {
        setChatBoxStatus(status)
    }

    const handleConversation = async (obj) => {
        setDefaultMsg('')
        setShowConversationContainer(true);
        const responseData: any = await fetchMessages({ conversationID: obj._id })

        if (!isNil(responseData) && responseData.length) {
            let selObj: any = obj;
            selObj.conversation = responseData || [];
            setSelectedConversation(selObj)
            let messageIDs: any = [];
            map(responseData, (msg: any) => {
                if (msg.direction == "incoming" && msg.status !== 'READ') {
                    messageIDs.push(msg._id)
                }
            })

            if (messageIDs.length) {
                let updateMessagesList = {
                    messageIDs: messageIDs,
                    readBy: {
                        user: userChatInfo._id,
                        readAt: new Date()
                    }
                }
                updateMessageList(updateMessagesList)
            }
        } else {
            let selObj: any = obj;
            selObj.conversation = [];
            setSelectedConversation(selObj)
        }
    }


    // todo: move to normalizer
    const getMsgFormatData = (obj: any, type) => {
        let msgObj: any = obj;
        msgObj.direction = type;
        msgObj.displayOption = msgObj.displayOption ? msgObj.displayOption : "TEXT";
        msgObj.time = moment(new Date()).format('hh:mm A');
        return msgObj;
    }

    const handleNavigation = async (orgID: any) => {
        setChatStatusState({
            ...chatStatusState,
            status: {
                supplier: false,
                product: false,
                order: false
            },
            info: {}
        });
        // setConversation({ conversation: [] })
        // setDefaultMsg('')
        //setDefaultSupplier('')
        history.push(`/supplier/${encode(orgID)}`)
    }


    const handleChatWidgetStatus = (status) => {
        setChatStatusState({
            ...chatStatusState,
            status: {
                supplier: false,
                product: false,
                order: false
            },
            info: {}
        });
        setChatWidgetStatus(status)
    }

    const handleFileUpload = (e) => {
        const { files } = e.target;
        handleImageChange(files[0], 'base64String')
    };

    const onClickUpload = () => {
        inputFile.current.click();
    };

    const handleImageChange = (fileObj: any, name: string) => {
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(fileObj);
            reader.onload = () => resolve(reader.result);
        }).then(async (base64String: any) => {
            //  console.log(base64String)

            const isOnlineUser = find(onlineUserlist, (o: any) => o.refID === selectedConversation.refID);

            //need to add isNill
            if (isOnlineUser) {

                let msgCreateReq = {
                    to: isOnlineUser.userID,
                    platform: process.env.ACCOUNT_TYPE,
                    message: {
                        sender: userChatInfo._id,
                        text: 'photo',
                        employee: profile ? profile._id : '',
                        employeeName: profile ? profile.fullName : '',
                    },
                    files: [{
                        fileName: fileObj.name,
                        fileType: "IMAGE",
                        base64String: base64String
                    }]
                }
                let msgCreate = await createMessage(msgCreateReq)
                setSendMsgState({ ...sendMsgState, create: 'idle' });

                let selConversationObj = cloneDeep(selectedConversation);
                let msgObj: any = {
                    direction: 'outgoing',
                    time: moment(new Date()).format('hh:mm A'),
                    displayOption: "TEXT",
                    attachments_data: []
                };
                msgObj['attachments_data'].push({
                    file_url: base64String
                });
                selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
                setSelectedConversation(selConversationObj);

            } else {
                let msgCreateReq = {
                    message: {
                        conversationID: selectedConversation.conversationID,
                        sender: userChatInfo._id,
                        text: 'photo',
                        employee: profile ? profile._id : '',
                        employeeName: profile ? profile.fullName : '',
                    },
                    files: [{
                        fileName: fileObj.name,
                        fileType: "IMAGE",
                        base64String: base64String
                    }]
                }
                let msgCreate = await createMessage(msgCreateReq)
                setSendMsgState({ ...sendMsgState, create: 'idle' });
                let selConversationObj = cloneDeep(selectedConversation);
                let msgObj: any = {
                    direction: 'outgoing',
                    time: moment(new Date()).format('hh:mm A'),
                    displayOption: "TEXT",
                    attachments_data: []
                };
                msgObj['attachments_data'].push({
                    file_url: base64String
                });
                selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
                setSelectedConversation(selConversationObj);

            }




            // setError(initialError);
            // setInput({ ...input, [name]: base64String });
            // setSubmitState({ ...submitState, update: 'active' });
        });

    }

    const onProductsOpen = async (obj) => {


        let filters = {
            orgID: obj.refID,
            displaySite: process.env.ACCOUNT_TYPE
        }

        const responseData = await fetchProductList(filters)

        if (!isNil(responseData)) {
            setProductList(responseData)
        } else {
            setProductList([])
        }

        setIsProducts(true)
    }

    const onOrdersOpen = async (order) => {
        console.log(order)
        let filters = { orderedBy: profileID, supplierID: order.refID, orderType: ['ECOM_RETAIL'] }
        const responseData = await fetchOrderList(filters)
        if (!isNil(responseData)) {
            setOrderList(responseData)
        }
        setIsOrders(true)
    }

    const closeModal = () => {
        setIsOrders(false)
        setIsProducts(false)
    }

    const getSelectedProducts = (selProd) => {
        closeModal()
        console.log(selProd)
        //  sendProductMsg(selProd)
        handleSendProductMsg(selProd)
    }

    const getSelectedOrders = (selOrder) => {
        closeModal()
        handleSendOrderMsg(selOrder)
        //  sendOrderMsg(selOrder)

    }


    const handleSendProductMsg = async (obj) => {

        let amount = obj.stockVariants.length ? obj.stockVariants[0].value : 0;
        amount = parseInt(amount);

        let msgCreateReq = {
            message: {
                conversationID: selectedConversation.conversationID,
                sender: userChatInfo._id,
                displayOption: "PRODUCT",
                employee: profile ? profile._id : '',
                employeeName: profile ? profile.fullName : '',
                text: `<div style='color:#000000;font-size:16px;font-weight:500'>${obj.product.productName}<br /><span style='color:#365BA9'>RM ${amount.toFixed(2)}</span></div>`
            },
            files: [{
                fileName: obj.product.images ? obj.product.images[0].file_data.fileName : '',
                fileType: "PRODUCT",
                s3Path: obj.product.images ? obj.product.images[0].file_data.s3Path : ''
            }]
        }
        let msgCreate = await createMessage(msgCreateReq)

        let selConversationObj = cloneDeep(selectedConversation);
        let msgObj: any = {
            direction: 'outgoing',
            time: moment(new Date()).format('hh:mm A'),
            attachments_data: [],
            displayOption: "PRODUCT",
            employee: profile ? profile._id : '',
            employeeName: profile ? profile.fullName : '',
            text: `<div style='color:#000000;font-size:16px;font-weight:500'>${obj.product.productName}<br /><span style='color:#365BA9'>RM ${amount}</span></div>`
        };
        msgObj['attachments_data'].push({
            file_url: obj.product.images ? obj.product.images[0].file_data.file_url : ''
        });
        selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
        setSelectedConversation(selConversationObj);
    }

    const handleSendOrderMsg = async (obj) => {

        let msgCreateReq = {
            message: {
                conversationID: selectedConversation.conversationID,
                sender: userChatInfo._id,
                displayOption: "ORDER",
                employee: profile ? profile._id : '',
                employeeName: profile ? profile.fullName : '',
                text: `<div style='line-height:0.5rem !important;padding: 10px;background: white;color: black;border-radius: 4px;'><div style='text-transform:Capitalize;font-size: 16px;color: #858C94;line-height:0.3rem'> <strong>#${obj.orderCode}</strong></div><br />
                <div style='text-transform:Capitalize;font-size:16px;color:'#0D1C2E';line-height:0.3rem'> <strong>Order Total: <span style='color:#196aaf'>RM ${obj.paymentDetails.total}</span> </strong></div><br />
                <div style='text-transform:Capitalize;font-size: 16px;color: #7DB83E;line-height:0.3rem'> <strong>${obj.status}</strong></div></div>`
            }
        }
        let msgCreate = await createMessage(msgCreateReq)
        let selConversationObj = cloneDeep(selectedConversation);
        let msgObj: any = {
            direction: 'outgoing',
            time: moment(new Date()).format('hh:mm A'),
            displayOption: "ORDER",
            employee: profile ? profile._id : '',
            employeeName: profile ? profile.fullName : '',
            text: `<div style='line-height:0.5rem !important;padding: 10px;background: white;color: black;border-radius: 4px;'><div style='text-transform:Capitalize;font-size: 16px;color: #858C94;line-height:0.3rem'> <strong>#${obj.orderCode}</strong></div><br />
            <div style='text-transform:Capitalize;font-size:16px;color:'#0D1C2E';line-height:0.3rem'> <strong>Order Total: <span style='color:#196aaf'>RM ${obj.paymentDetails.total}</span> </strong></div><br />
            <div style='text-transform:Capitalize;font-size: 16px;color: #7DB83E;line-height:0.3rem'> <strong>${obj.status}</strong></div></div>`

        };
        selConversationObj?.conversation ? selConversationObj.conversation.push(msgObj) : [msgObj];
        setSelectedConversation(selConversationObj);
    }

    return (
        <div className="chat-view">

            <ChatComponent
                list={conversationList}
                conversation={conversation}
                onSelUser={handleConversation}
                onSendMessage={onSendMessage}
                setChatWidgetStatus={handleChatWidgetStatus}
                chatBoxStatus={chatBoxStatus}
                defaultMsg={defaultMsg}
                navigateToSupplierPage={handleNavigation}
                isSupplier={defaultSupplier}
                onlineUserlist={onlineUserlist}
                onClickUpload={onClickUpload}
                sendStatus={sendMsgState.create}
                onProductsUpload={onProductsOpen}
                onOrdersUpload={onOrdersOpen}
                showConversationContainer={showConversationContainer}
                setShowConversationContainer={setShowConversationContainer}
            />

            <input
                style={{ display: "none" }}
                accept="image/png, image/jpeg"
                ref={inputFile}
                onChange={handleFileUpload}
                type="file"
            />

            <BasicModal
                destroyOnClose={true}
                isOpen={isOrders}
                isClosable={true}
                onClose={closeModal}
                isMaskClosable={true}
            >
                <ChooseOrders
                    orderList={orderList}
                    selectedOrder={getSelectedOrders}
                />
            </BasicModal>

            <BasicModal
                destroyOnClose={true}
                isOpen={isProducts}
                isClosable={true}
                onClose={closeModal}
                isMaskClosable={true}
            >
                <ChooseProducts
                    productList={productList}
                    selectedProducts={getSelectedProducts}
                />
            </BasicModal>

        </div>
    );
}

export default ChatConversation;


